import { render } from "./App.vue?vue&type=template&id=9b021056"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9b021056&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Coverse Landing RU/_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__